import React, { useState, useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import './section.scss';
import { IPageListItem } from '../../../types/landing-api-response.model';

export default function PageListItem({
  favItem,
  handleNavigateToFavorite
}: {
  favItem: IPageListItem;
  handleNavigateToFavorite: Function;
}) {
  // local state for loading while navigating to scenario
  const [isScenarioLoading, setIsScenarioLoading] = useState(false);

  // handle for navigating to favorite
  const handleFavorite = () => {
    // setting is scenario loading true
    setIsScenarioLoading(true);

    // handler for navigating to favorite page
    handleNavigateToFavorite(favItem);
  };

  //   renderring favorite item (item label and icon)
  return (
    <div className='fav-item-div' onClick={handleFavorite}
      onKeyDown={(e: { key: string; }) => {
        if (e.key == 'Enter' || e.key == '') {
          handleFavorite();
        }
      }}
    >
      <div className='fav-title-div'>
        <div className='fav-main-title'>{favItem.alias}</div>
      </div>
      {isScenarioLoading ? (
        <CircularProgress size={20} />
      ) : (
        <KeyboardArrowRightIcon sx={{ color: '#1E1E1E', fontSize: '16px' }} />
      )}
    </div>
  );
}
